export const getImageUrl = (path: string) => {
  const isDev = ['development', 'staging'].includes(import.meta.env.VITE_ENV);

  try {
    if (isDev) {
      return `/${path}`;
    }

    return new URL(path, import.meta.env.VITE_PUBLIC_PATH).href;
  } catch {
    return new URL(path, window.location.origin).href;
  }
};
